import { API_CONFIG } from "../config/constants";

/**
 * Genera mensaje personalizado para WhatsApp
 * @param {Object} tramite - Datos del trámite
 * @param {string} categoryName - Nombre de la categoría
 * @returns {string} Mensaje codificado para URL
 */
export const generateWhatsAppMessage = (tramite, categoryName) => {
  let message = `Hola, me interesa el trámite: *${tramite.name}*\n\n`;
  message += `<Clipboard /> *Descripción:* ${tramite.description}\n\n`;
  message += `<Banknote /> *Tipo de Precio:* ${tramite.price_type === "fijo" ? "<Banknote /> Precio Fijo" : "<ChartNoAxesColumn /> Variable"}\n`;

  if (tramite.fixed_price) {
    message += `💵 *Precio:* $${tramite.fixed_price} MXN\n`;
  }

  message += `⏱️ *Tiempo estimado:* ${tramite.estimated_time_days} días\n\n`;
  message += `📂 *Categoría:* ${categoryName}\n\n`;
  message += `¿Podrían proporcionarme más información y cotización personalizada?`;

  return encodeURIComponent(message);
};

/**
 * Abre chat de WhatsApp con mensaje pre-rellenado
 * @param {Object} tramite - Datos del trámite
 * @param {string} categoryName - Nombre de la categoría
 */
export const openWhatsAppChat = (tramite, categoryName) => {
  const message = generateWhatsAppMessage(tramite, categoryName);
  const whatsappURL = `https://wa.me/${API_CONFIG.WHATSAPP_NUMBER}?text=${message}`;
  window.open(whatsappURL, "_blank");
};

/**
 * Valida si WhatsApp está disponible
 * @returns {boolean} True si está disponible
 */
export const isWhatsAppAvailable = () => {
  return !!API_CONFIG.WHATSAPP_NUMBER;
};
